import { paginationStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryPagination";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

paginationStyles.pagination = {
    cssOverrides: {
        pagination: css`
            && {
                margin: 0;
                margin-top: 20px;
            }
        `,

        perPageSelect: css`
            ${mediaQueriesBP.minMD} {
                width: auto;
            }

            ${mediaQueriesBP.maxMD} {
                && {
                    margin-bottom: 12px;
                }
            }
        `,

        linkList: css`
            ${mediaQueriesBP.minMD} {
                width: auto;
            }
        `,
    },
};
